import { render, staticRenderFns } from "./file-info.vue?vue&type=template&id=1917eb3a&scoped=true&"
import script from "./file-info.vue?vue&type=script&lang=js&"
export * from "./file-info.vue?vue&type=script&lang=js&"
import style0 from "./file-info.vue?vue&type=style&index=0&id=1917eb3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1917eb3a",
  null
  
)

export default component.exports